import { FetchAPI } from 'utils/fetch/fetch-api';
import { RequestQuery } from 'utils/types/request-types';
import { SalesDTO } from 'utils/types/sales';

class SalesService extends FetchAPI {
	getSales = (query: RequestQuery): Promise<SalesDTO> => this.get<SalesDTO>(query);
}

export { SalesService };
